import React, { useEffect, useMemo, useState } from "react";
import { Link } from "react-router-dom";
import { Button, Col, Form, Row } from "react-bootstrap";
import { connect } from "react-redux";

import * as actions from "store/actions";

// img
import GoogleCalIcn from "../../../../../../Assets/Images/icn/googleCal.svg";
import FScriptIcn from "../../../../../../Assets/Images/icn/fullScript.svg";
import PBetterIcn from "../../../../../../Assets/Images/icn/PracticeBetter.svg";

// icn
import { ReactComponent as StripeIcn } from "../../../../../../Assets/Images/icn/stripe.svg";
import { ReactComponent as LinkIcn } from "../../../../../../Assets/Images/icn/Link.svg";
import {
  connectFullscriptAccount,
  connectGoogleCalendar,
  connectStripeAccount,
  disconnectFullscriptAccount,
  disconnectGoogleCalendar,
  disconnectPracticeBetterAccount,
  disconnectStripeAccount,
  generatePracticeBetterKey,
  getIntegrationStatus,
  getStripeLoginLink,
  saveSelectedCalendar,
  updateGoogleCalendarSettings,
} from "store/services/accountSettingService";
import {
  HelpGoogleLinkAccount,
  HelpStripeLinkAccount,
  HelpFullScriptLinkAccount,
  HelpPracticeLinkAccount,
  HelpAcceptPayment,
  HelpPackagesCreate,
} from "Routes/paths";
import Select from "react-select";
import { STRIPE_SUPPORTED_COUNTRIES } from "common/constants";
import { CONFIRM_POPUP, ERROR_MESSAGE } from "common/constantMessage";
import CalendarPicker from "components/Modals/CalendarPicker";

const ThirdPartyIntegeration = ({
  dispatch,
  stripeConnection,
  googleCalendarConnection,
  fullscriptConnection,
  practiceBetterConnection,
}) => {
  const [linkGoogleDisabled, setLinkGoogleDisabled] = useState(false);

  // calendar 
  const [isCalendarPopup, setIsCalendarPopup] = useState(false);
  const [selectedCalendar, setSelectedCalendar] = useState(null);



  // stripe states
  const [linkStripeDisabled, setLinkStripeDisabled] = useState(false);
  const [stripeChooseCountryEnabled, setStripeChooseCountryEnabled] =
    useState(false);
  const [stripeSelectedCountry, setStripeSelectedCountry] = useState("US");

  // fullscript states
  const [showFullscriptCountries, setShowFullscriptCountries] = useState(false);
  const [selectedCountry, setSelectedCountry] = useState(null);

  // practice better states
  const [practiceBetterApiKey, setPracticeBetterApiKey] = useState(null);
  const [pbKeyCopied, setPbKeyCopied] = useState(false);

  // googleSettings
  const [allowFreeSlots, setAllowFreeSlots] = useState(false);
  const [showBusyEventsState, setShowBusyEventsState] = useState(false);

  const stripeCountriesOptions = useMemo(() => {
    return STRIPE_SUPPORTED_COUNTRIES.map((country) => ({
      value: country.code,
      label: country.name,
    }));
  }, [STRIPE_SUPPORTED_COUNTRIES]);

  const stripeDefaultCountry = useMemo(
    () => ({
      value: stripeSelectedCountry,
      label: STRIPE_SUPPORTED_COUNTRIES.find(
        (country) => country.code === stripeSelectedCountry
      )?.name,
    }),
    [stripeSelectedCountry, STRIPE_SUPPORTED_COUNTRIES]
  );

  useEffect(() => {
    getThirdPartyIntegrations();
  }, []);

  let timeoutId = null;
  useEffect(() => {
    return () => {
      clearTimeout(timeoutId);
      setPbKeyCopied(false);
    };
  }, []);

  // set stripe default country from connection response
  useEffect(() => {
    if (!stripeConnection?.connection_response?.country) {
      return;
    }

    setStripeSelectedCountry(stripeConnection?.connection_response?.country);
  }, [stripeConnection?.connection_response?.country]);

  const handleSelectFullscriptCountry = (country) => {
    setSelectedCountry(country);
    linkFullscript(country);
  };

  // const getThirdPartyIntegrations = async () => {
  //   try {
  //     dispatch(actions.persist_store({ loader: true }));
  //     let res = await dispatch(getIntegrationStatus());
  //     dispatch(actions.persist_store({ loader: false }));

  //   } catch (err) {
  //     dispatch(actions.persist_store({ loader: false }));
  //     console.log(err);
  //   }
  // };



  const getThirdPartyIntegrations = async () => {
    try {
      dispatch(actions.persist_store({ loader: true }));
      let res = await dispatch(getIntegrationStatus());
      dispatch(actions.persist_store({ loader: false }));

      if (res?.success && Array.isArray(res.body)) {
        const googleIntegration = res.body.find(
          (item) => item.connection_type === "google"
        );

        if (googleIntegration?.configuration) {
          setAllowFreeSlots(!!googleIntegration.configuration.onlyAllowIfFree);
          setShowBusyEventsState(
            !!googleIntegration.configuration.showBusyEvents
          );
          setSelectedCalendar({
            id: googleIntegration?.configuration?.selectedCalendarId,
            summary: googleIntegration?.configuration?.selectedCalendarSummary,
            primary: googleIntegration?.configuration?.selectedCalendarPrimary
          })
        }
      }
    } catch (err) {
      dispatch(actions.persist_store({ loader: false }));
      console.log(err);
    }
  };

  const linkStripe = async (e, isResuming) => {
    try {
      if (!stripeSelectedCountry) {
        ERROR_MESSAGE("Please select your country.");
        return;
      }

      if (!isResuming) {
        let selectedCountry = STRIPE_SUPPORTED_COUNTRIES.find(
          (country) => country.code === stripeSelectedCountry
        )?.name;
        let confirmationMsg = `Please note that once submitted, the account will be created on Stripe under the selected country.`;
        let confirm = await CONFIRM_POPUP(confirmationMsg, {
          buttons: ["Cancel", "Yes"],
        });
        if (!confirm) {
          return;
        }
      }

      setLinkStripeDisabled(true);
      dispatch(actions.persist_store({ loader: true }));
      let payload = {
        country: stripeSelectedCountry,
      };
      let res = await connectStripeAccount(payload);
      if (res.success === true && res.body.url) {
        window.location = res.body.url;
      }
      // dispatch(actions.persist_store({ loader: false }));
      // setLinkStripeDisabled(false);
    } catch (err) {
      console.log(err);
      dispatch(actions.persist_store({ loader: false }));
      setLinkStripeDisabled(false);
    }
  };

  const unlinkStripe = async () => {
    try {
      let confirm = await CONFIRM_POPUP();
      if (!confirm) {
        return;
      }

      setLinkStripeDisabled(true);
      dispatch(actions.persist_store({ loader: true }));
      await dispatch(disconnectStripeAccount());
      dispatch(actions.persist_store({ loader: false }));
      setLinkStripeDisabled(false);
    } catch (err) {
      console.log(err);
      dispatch(actions.persist_store({ loader: false }));
      setLinkStripeDisabled(false);
    }
  };

  const openStripeDashboard = async () => {
    const stripeWindow = window.open('', '_blank');

    // Popup blocked fallback
    if (!stripeWindow) {
      alert('Please allow popups to open Stripe dashboard.');
      return;
    }

    // Write loading UI immediately
    stripeWindow.document.open();
    stripeWindow.document.writeln(`
      <!DOCTYPE html>
      <html>
        <head>
          <title>Redirecting to Stripe</title>
          <style>
            body {
              display: flex;
              align-items: center;
              justify-content: center;
              height: 100vh;
              margin: 0;
              background: #fafafa;
              color: #333;
              font-family: "Segoe UI" !important;
            }
            .box {
              text-align: center;
            }
            .spinner {
              margin: 16px auto;
              width: 32px;
              height: 32px;
              border: 3px solid #ddd;
              border-top-color: #f4694b;
              border-radius: 50%;
              animation: spin 0.8s linear infinite;
            }
            @keyframes spin {
              to { transform: rotate(360deg); }
            }
          </style>
        </head>
        <body>
          <div class="box">
            <div class="spinner"></div>
            <p>Please wait while we redirect you to Stripe…</p>
          </div>
        </body>
      </html>
    `);
    stripeWindow.document.close();

    try {
      dispatch(actions.persist_store({ loader: true }));

      const res = await getStripeLoginLink();

      if (res?.success && res?.body?.url) {
        stripeWindow.location.href = res.body.url;
      } else {
        stripeWindow.close();
      }
    } catch (err) {
      console.error(err);
      stripeWindow.close();
    } finally {
      dispatch(actions.persist_store({ loader: false }));
    }
  };



  const linkGoogle = async () => {
    try {
      setLinkGoogleDisabled(true);
      dispatch(actions.persist_store({ loader: true }));
      let res = await connectGoogleCalendar();
      if (res.success === true && res.body.url) {
        window.location = res.body.url;
      }
      dispatch(actions.persist_store({ loader: false }));
      setLinkGoogleDisabled(false);
    } catch (err) {
      console.log(err);
      dispatch(actions.persist_store({ loader: false }));
      setLinkGoogleDisabled(false);
    }
  };

  const unlinkGoogle = async () => {
    try {
      let confirm = await CONFIRM_POPUP();
      if (!confirm) {
        return;
      }

      setLinkGoogleDisabled(true);
      dispatch(actions.persist_store({ loader: true }));
      await dispatch(disconnectGoogleCalendar());
      dispatch(actions.persist_store({ loader: false }));
      setLinkGoogleDisabled(false);
    } catch (err) {
      console.log(err);
      dispatch(actions.persist_store({ loader: false }));
      setLinkGoogleDisabled(false);
    }
  };

  const linkFullscript = async (country) => {
    try {
      let data = {
        country,
      };
      dispatch(actions.persist_store({ loader: true }));
      let res = await connectFullscriptAccount(data);
      if (res.success === true && res.body.url) {
        window.location = res.body.url;
      }
      // if (res.success === true && res.body.url) {
      //   window.open(res.body.url);
      // }
      // dispatch(actions.persist_store({ loader: false }));
    } catch (err) {
      console.log(err);
      dispatch(actions.persist_store({ loader: false }));
    }
  };

  const unlinkFullscript = async () => {
    try {
      let confirm = await CONFIRM_POPUP();
      if (!confirm) {
        return;
      }

      dispatch(actions.persist_store({ loader: true }));
      await dispatch(disconnectFullscriptAccount());
      dispatch(actions.persist_store({ loader: false }));
    } catch (err) {
      console.log(err);
      dispatch(actions.persist_store({ loader: false }));
    }
  };

  const generatePBKey = async () => {
    try {
      dispatch(actions.persist_store({ loader: true }));
      let response = await generatePracticeBetterKey();
      console.log("response", response);
      if (response?.success === true && response?.body?.apiKey) {
        setPracticeBetterApiKey(response?.body?.apiKey);
      }
      dispatch(actions.persist_store({ loader: false }));
    } catch (err) {
      console.log(err);
      dispatch(actions.persist_store({ loader: false }));
    }
  };

  const unlinkPracticeBetter = async () => {
    try {
      let confirm = await CONFIRM_POPUP();
      if (!confirm) {
        return;
      }

      dispatch(actions.persist_store({ loader: true }));
      await dispatch(disconnectPracticeBetterAccount());
      dispatch(actions.persist_store({ loader: false }));
    } catch (err) {
      console.log(err);
      dispatch(actions.persist_store({ loader: false }));
    }
  };

  const handleFreeSlotsToggle = async () => {
    const updatedFreeSlot = !allowFreeSlots;
    const currentBusy = showBusyEventsState;

    setAllowFreeSlots(updatedFreeSlot);
    dispatch(actions.persist_store({ loader: true }));

    try {
      await updateGoogleCalendarSettings({
        onlyAllowIfFree: updatedFreeSlot,
        showBusyEvents: currentBusy,
      });
    } catch (err) {
      console.error("Failed to update calendar settings:", err);
    } finally {
      dispatch(actions.persist_store({ loader: false }));
    }
  };

  const handleBusyEventsToggle = async () => {
    const updatedBusy = !showBusyEventsState;
    const currentFree = allowFreeSlots;

    setShowBusyEventsState(updatedBusy);
    dispatch(actions.persist_store({ loader: true }));

    try {
      await updateGoogleCalendarSettings({
        onlyAllowIfFree: currentFree,
        showBusyEvents: updatedBusy,
      });
    } catch (err) {
      console.error("Failed to update calendar settings:", err);
    } finally {
      dispatch(actions.persist_store({ loader: false }));
    }
  };


  const handleSaveCalendar = async (calendar) => {
    try {
      if (!calendar?.id) {
        console.error("No calendar selected");
        return;
      }

      const payload = {
        onlyAllowIfFree: true,
        showBusyEvents: true,
        selectedCalendarId: calendar?.id,
      };

      dispatch(actions.persist_store({ loader: true }));

      const resp = await saveSelectedCalendar(payload);
      if (resp.success) {
        getThirdPartyIntegrations()
        setIsCalendarPopup(false)
      }


    } catch (error) {
      console.error(error);
    }
    finally {
      dispatch(actions.persist_store({ loader: false }));
    }
  };

  return (
    <>
      <CalendarPicker
        onOffPop={isCalendarPopup}
        setOnOffPop={setIsCalendarPopup}
        heading="Select Calendar"
        setSelectedCalendar={setSelectedCalendar}
        selectedCalendar={selectedCalendar}
        handleSubmit={handleSaveCalendar}
      />

      <div className="top py-2">
        <h3 className="m-0 py-1 fw-bold">3rd Party Integrations</h3>
      </div>
      <div className="TabBody py-3">
        <div className="py-2">
          <ul className="list-unstyled ps-0 mb-0 pt-2">
            <li className="d-flex align-items-start py-3 position-relative">
              {stripeConnection &&
                stripeConnection.connection_response.status === true && (
                  <Button
                    className="d-flex align-items-center CstmLabel justify-content-center position-absolute"
                    style={{
                      right: "10px",
                      top: "10px",
                      background: "#F1FFF1",
                      color: "#548B54",
                      borderColor: "#548B54",
                    }}
                  >
                    {" "}
                    Linked
                  </Button>
                )}
              <div className="imgWrp me-2">
                <StripeIcn />
              </div>
              <div className="content">
                <h6 className="fw-sbold m-0 pb-1">Stripe</h6>
                {stripeConnection &&
                  stripeConnection.connection_response.status === true ? (
                  <>
                    <p className="m-0">Your Stripe account is linked.</p>
                    <p className="m-0">
                      See how to accept payments for Appointments & Packages:
                    </p>
                    <ul className="m-0">
                      <li className="py-1">
                        <Link
                          to={HelpAcceptPayment}
                          target="_blank"
                          className=" underline"
                        >
                          Accept Appointment Payments
                        </Link>
                      </li>
                      <li className="py-1">
                        <Link
                          to={HelpPackagesCreate}
                          target="_blank"
                          className=" underline"
                        >
                          Create Client Packages
                        </Link>
                      </li>
                      <li className="py-1">
                        <Link
                          // onClick={openStripeDashboard}
                          to={"https://dashboard.stripe.com/"}
                          target="_blank"
                          className=" underline"
                        >
                          Open Stripe Portal
                        </Link>
                      </li>
                    </ul>
                  </>
                ) : (
                  <>
                    {!stripeConnection ? (
                      <>
                        {stripeChooseCountryEnabled ? (
                          <div className="my-2">
                            <p className="m-0">
                              Please select your country from the list below
                            </p>
                            <Select
                              defaultValue={stripeDefaultCountry}
                              options={stripeCountriesOptions}
                              onChange={(selected) => {
                                setStripeSelectedCountry(selected.value);
                              }}
                              className="my-2"
                            />
                            <Button
                              className="d-flex fw-sbold my-2 align-items-center justify-content-center commonBtn btnSm"
                              onClick={linkStripe}
                              disabled={!stripeSelectedCountry}
                            >
                              Proceed
                            </Button>
                          </div>
                        ) : (
                          <Button
                            className="d-flex fw-sbold my-2 align-items-center justify-content-center commonBtn btnSm"
                            onClick={() => {
                              setStripeChooseCountryEnabled(true);
                            }}
                            disabled={linkStripeDisabled}
                          >
                            <span className="icn me-2">
                              <LinkIcn />
                            </span>{" "}
                            Link your Stripe account
                          </Button>
                        )}
                      </>
                    ) : (
                      stripeConnection &&
                      stripeConnection.connection_response.status !== true && (
                        <Button
                          className="d-flex fw-sbold my-2 align-items-center justify-content-center commonBtn btnSm"
                          onClick={() => {
                            linkStripe(null, true);
                          }}
                          disabled={linkStripeDisabled}
                        >
                          <span className="icn me-2">
                            <LinkIcn />
                          </span>{" "}
                          Finish linking with Stripe
                        </Button>
                      )
                    )}
                    <p className="m-0">
                      Not familiar with Stripe?{" "}
                      <Link
                        to={HelpStripeLinkAccount}
                        target="_blank"
                        className="underline"
                      >
                        Learn more about Stripe here.
                      </Link>{" "}
                    </p>
                  </>
                )}
                {stripeConnection && (
                  <p className="m-0">
                    <Link onClick={unlinkStripe} className="underline">
                      Unlink your Stripe account
                    </Link>
                  </p>
                )}
              </div>
            </li>
            <li className="d-flex align-items-start py-3 position-relative">
              {googleCalendarConnection &&
                googleCalendarConnection.connected === true && (
                  <Button
                    className="d-flex align-items-center CstmLabel justify-content-center position-absolute"
                    style={{
                      right: "10px",
                      top: "10px",
                      background: "#F1FFF1",
                      color: "#548B54",
                      borderColor: "#548B54",
                    }}
                  >
                    {" "}
                    Linked
                  </Button>
                )}
              <div className="imgWrp me-2 GOOGLE">
                {/* <GoogleCalIcn /> */}
                <img src={GoogleCalIcn} alt="" className="img-fluid" />
              </div>
              <div className="content">
                <div className="d-flex justify-content-between">
                  <h6 className="fw-sbold m-0 pb-1">Google Calendar</h6>
                </div>
                <p className="m-0">
                  Sync your Scheduler Appointments with your Google Calendar.
                  View the{" "}
                  <Link
                    to={HelpGoogleLinkAccount}
                    target="_blank"
                    className="underline"
                  >
                    Google Calendar Integration Guide
                  </Link>{" "}
                  for step by step instructions.
                </p>
                {googleCalendarConnection &&
                  googleCalendarConnection.connected === true && (
                    <div>
                      <p className="m-0">
                        <Link onClick={unlinkGoogle} className="underline">
                          Unlink your Google account
                        </Link>
                      </p>
                      <div className="form-check form-switch d-flex align-items-center row p-0 mt-2">

                        <div className="d-flex gap-1 align-items-center">
                          <label
                            className="form-check-label"
                            for=""
                          >
                            {
                              selectedCalendar?.summary?.length ? (
                                <div className="d-flex align-items-center gap-2">
                                  {`Saving appointments to ${selectedCalendar?.summary} `}
                                  <span
                                    className={`badge ${selectedCalendar?.primary ? "bg-primary" : "bg-secondary"
                                      }`}
                                  >
                                    {selectedCalendar?.primary ? "Primary" : "Secondary"}
                                  </span>
                                </div>
                              ) : (
                                "Saved to default calendar"
                              )
                            }
                          </label>
                          <button
                            onClick={() => setIsCalendarPopup(true)}
                            className="bg-transparent border-0 d-flex"
                          >
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-pencil-square" viewBox="0 0 16 16">
                              <path d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z" />
                              <path fill-rule="evenodd" d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5z" />
                            </svg>
                          </button>
                        </div>
                      </div>

                      <p className="mt-2 fw-bold">More settings:</p>
                      <div className="px-5">
                        <div className="form-check form-switch d-flex align-items-center row">
                          <input
                            className="form-check-input border-secondary"
                            type="checkbox"
                            role="switch"
                            id="switchCheckDefault"
                            checked={allowFreeSlots}
                            onChange={handleFreeSlotsToggle}
                          />
                          <label
                            className="form-check-label"
                            for="switchCheckDefault"
                          >
                            Allow only appointments if my Google Calendar is also
                            free.
                          </label>
                        </div>
                        <div className="form-check form-switch d-flex align-items-center row">
                          <input
                            className="form-check-input border-secondary"
                            type="checkbox"
                            role="switch"
                            id="switchCheckDefault2"
                            checked={showBusyEventsState}
                            onChange={handleBusyEventsToggle}
                          />
                          <label
                            className="form-check-label"
                            for="switchCheckDefault2"
                          >
                            Show my ‘busy’ Google Calendar events on my Nutri-Q
                            Appointments calendar view.
                          </label>
                        </div>

                      </div>
                    </div>
                  )}
                {(!googleCalendarConnection ||
                  !googleCalendarConnection.connected) && (
                    <Button
                      className="d-flex fw-sbold my-2 align-items-center justify-content-center btnSm commonBtn"
                      onClick={linkGoogle}
                      disabled={linkGoogleDisabled}
                    >
                      <span className="icn me-2">
                        <LinkIcn />
                      </span>{" "}
                      Link your Google account
                    </Button>
                  )}
              </div>
            </li>
            <li className="d-flex align-items-start py-3 position-relative">
              {practiceBetterConnection && (
                <Button
                  className="d-flex align-items-center CstmLabel justify-content-center position-absolute"
                  style={{
                    right: "10px",
                    top: "10px",
                    background: "#F1FFF1",
                    color: "#548B54",
                    borderColor: "#548B54",
                  }}
                >
                  {" "}
                  Linked
                </Button>
              )}
              <div className="imgWrp me-2 GOOGLE">
                <img src={PBetterIcn} alt="" className="img-fluid" />
              </div>
              <div className="content">
                <h6 className="fw-sbold m-0 pb-1">Practice Better</h6>
                {practiceBetterConnection ? (
                  <>
                    <p className="m-0">
                      Your Practice Better account is now linked
                    </p>
                    <p className="m-0 py-1">
                      <Link
                        className="underline d-block"
                        onClick={unlinkPracticeBetter}
                      >
                        Unlink your Practice Better account
                      </Link>{" "}
                    </p>
                  </>
                ) : (
                  <>
                    {practiceBetterApiKey ? (
                      <>
                        <p className="m-0">
                          To link your Practice Better account, copy the Key
                          below and then <a href="#">click here</a> to be taken
                          to the 3rd Party Integrations section of your Practice
                          Better account. Once on that page, scroll down to the
                          Nutri-Q section and follow the instructions, pasting
                          in the Key from Nutri-Q when asked. Once that's
                          complete,{" "}
                          <Link onClick={getThirdPartyIntegrations}>
                            click here to refresh the status
                          </Link>{" "}
                          and verify that the accounts are now linked.
                        </p>
                        <Row className="py-2 align-items-center">
                          <Col lg="10">
                            <input
                              className="form-control"
                              value={practiceBetterApiKey}
                              disabled
                            />
                          </Col>
                          <Col lg="2">
                            <Button
                              className="d-flex align-items-center justify-content-center commonBtn btnSm"
                              onClick={() => {
                                try {
                                  navigator.clipboard.writeText(
                                    practiceBetterApiKey
                                  );
                                  setPbKeyCopied(true);
                                  timeoutId = setTimeout(() => {
                                    setPbKeyCopied(false);
                                  }, 3000);
                                } catch (err) {
                                  console.log(
                                    "Failed to copy to the clipboard"
                                  );
                                }
                              }}
                            >
                              {pbKeyCopied ? "Copied!" : "Copy Key"}
                            </Button>
                          </Col>
                        </Row>
                        <p className="m-0">
                          View the{" "}
                          <Link
                            className="underline"
                            to={HelpPracticeLinkAccount}
                            target="_blank"
                          >
                            Practice Better Integration Guide
                          </Link>{" "}
                          for step by step instructions.
                        </p>
                      </>
                    ) : (
                      <>
                        <p className="m-0">
                          Link with your Practice Better account to send NAQs
                          and receive results from within Practice Better. View
                          the{" "}
                          <Link
                            className="underline"
                            to={HelpPracticeLinkAccount}
                            target="_blank"
                          >
                            Practice Better Integration Guide
                          </Link>{" "}
                          for step by step instructions.
                        </p>
                        <Button
                          className="d-flex fw-sbold my-2 align-items-center justify-content-center commonBtn btnSm"
                          onClick={generatePBKey}
                        >
                          <span className="icn me-2">
                            <LinkIcn />
                          </span>{" "}
                          Link your Practice Better account
                        </Button>
                      </>
                    )}
                  </>
                )}
              </div>
            </li>
            <li className="d-flex align-items-start py-3 position-relative">
              {fullscriptConnection && (
                <Button
                  className="d-flex align-items-center CstmLabel justify-content-center position-absolute"
                  style={{
                    right: "10px",
                    top: "10px",
                    background: "#F1FFF1",
                    color: "#548B54",
                    borderColor: "#548B54",
                  }}
                >
                  {" "}
                  Linked
                </Button>
              )}
              <div className="imgWrp me-2 GOOGLE">
                {/* <FScriptIcn /> */}
                <img src={FScriptIcn} alt="" className="img-fluid" />
              </div>
              <div className="content">
                <h6 className="fw-sbold m-0 pb-1">Full Script</h6>
                {fullscriptConnection ? (
                  <>
                    <p className="m-0">
                      Your Fullscript account is linked. <br />
                      View the{" "}
                      <Link
                        to={HelpFullScriptLinkAccount}
                        className="underline"
                        target="_blank"
                      >
                        Fullscript Integration Guide
                      </Link>{" "}
                      to see how to:
                    </p>
                    <ul className="m-0">
                      <li className="py-1">Link Clients</li>
                      <li className="py-1">Create Recommendations</li>
                      <li className="py-1">
                        Generate Recommendations from a NAQ
                      </li>
                      <li className="py-1">View Client Orders</li>
                    </ul>
                    <p className="m-0 py-1">
                      {/* <b>Linked Fullscript Practitioner:</b> Practitioner Ln
                      (fsprac@mailinator.com) */}
                      <Link
                        className="underline d-block"
                        onClick={unlinkFullscript}
                      >
                        Unlink your Fullscript account
                      </Link>{" "}
                    </p>
                  </>
                ) : (
                  <>
                    {showFullscriptCountries ? (
                      <>
                        <p className="m-0 fw-bold">
                          In what country do you practice?
                        </p>
                        <ul className="d-flex p-0 py-2 gap-10">
                          <li
                            className={`btn btn-transparent border-1 border-black ${selectedCountry == "us" ? "active" : ""
                              }`}
                            onClick={() => {
                              handleSelectFullscriptCountry("us");
                            }}
                          >
                            United States
                          </li>
                          <li
                            className={`btn btn-transparent border-1 border-black ${selectedCountry == "ca" ? "active" : ""
                              }`}
                            onClick={() => {
                              handleSelectFullscriptCountry("ca");
                            }}
                          >
                            Canada
                          </li>
                        </ul>
                      </>
                    ) : (
                      <>
                        <p className="m-0">
                          Link your Fullscript account to create recommendations
                          using products from your Fullscript dispensary. View
                          the{" "}
                          <Link
                            to={HelpFullScriptLinkAccount}
                            target="_blank"
                            className="underline"
                          >
                            Fullscript Integration Guide
                          </Link>{" "}
                          for step by step instructions.
                        </p>
                        <Button
                          className="d-flex fw-sbold my-2 align-items-center justify-content-center commonBtn btnSm"
                          onClick={() => {
                            setShowFullscriptCountries(true);
                          }}
                        >
                          <span className="icn me-2">
                            <LinkIcn />
                          </span>{" "}
                          Link your Fullscript account
                        </Button>
                      </>
                    )}
                  </>
                )}
              </div>
            </li>
          </ul>
        </div>
      </div>
    </>
  );
};

const mapStateToPros = (state) => {
  let stripeConnection = state.AccountSetting.integrations.find(
    (integration) => integration.connection_type == "stripe"
  );
  let googleCalendarConnection = state.AccountSetting.integrations.find(
    (integration) => integration.connection_type == "google"
  );
  let fullscriptConnection = state.AccountSetting.integrations.find(
    (integration) => integration.connection_type == "full_script"
  );
  let practiceBetterConnection = state.AccountSetting.integrations.find(
    (integration) => integration.connection_type == "practice_better"
  );
  if (googleCalendarConnection) {
    googleCalendarConnection.connected = Boolean(
      googleCalendarConnection?.connection_response.access_token
    );
  }
  return {
    stripeConnection,
    googleCalendarConnection,
    fullscriptConnection,
    practiceBetterConnection,
  };
};

function mapDispatchToProps(dispatch) {
  return { dispatch };
}

export default connect(
  mapStateToPros,
  mapDispatchToProps
)(ThirdPartyIntegeration);
